import { Component, OnInit, Input, Output, ViewChild, TemplateRef, Inject, EventEmitter } from '@angular/core';
//import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../services/index';


@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: 'photos.component.html',
})
export class PhotoDialog implements OnInit {
    phdata:any[];
    @Output() photoDetail = new EventEmitter();

    ngOnInit() {

    }
    constructor(public sharedserv:SharedService/*,
        public dialogRef: MatDialogRef<PhotoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) */ ){
        //this.phdata = data;
    }
    /* onNoClick(): void {
        this.dialogRef.close();
    } */
    photoDet(event) {
        let params={
            designno:this.phdata['designno'],
            att:this.phdata['src']
        }
        this.sharedserv.photo.emit(params);

    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/DesignPhotos/photos.component.ts